import { render, staticRenderFns } from "./Bandeiras.vue?vue&type=template&id=e3e90888&scoped=true&"
import script from "./Bandeiras.vue?vue&type=script&lang=js&"
export * from "./Bandeiras.vue?vue&type=script&lang=js&"
import style0 from "./Bandeiras.vue?vue&type=style&index=0&id=e3e90888&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3e90888",
  null
  
)

export default component.exports